module.exports = __webpack_public_path__ + "img/lc.747ed66e.jpg";